'use strict';

/**
 * Activates the logout link under the user in the menu
 */
let setUpLogoutLink = function() {
	let logoutURL = '/code/views/ajax/users/logout.php';
	let logoutLink = $('a[href="/#logout"]');

	logoutLink.off('click');
	logoutLink.on('click', function() {
		logoutLink.html('<span>Logging Out</span> <i class="fa fa-cog fa-spin" aria-hidden="true"></i>');
		$.ajax({
			type: 'POST',
			url: logoutURL,
			data: {},
			success: function() {
				window.location.href = '/login.html?origin_page=' + encodeURIComponent(window.location.pathname);
			},
			error: function() {
				logoutLink.html('<span>Log Out Failed</span>');
			}
		});
		return false;
	});
};

/**
 * Updates the user's first name in the navigation
 */
let init = function(firstName) {
	let userDisplay;
	let $label = $('label[for="drop-username"]');

	$label.tooltip('dispose');

	if (firstName.length > 8) {
		userDisplay = firstName.substring(0, 8) + '...';
	} else {
		userDisplay = firstName;
	}

	$label.html('<span>' + userDisplay + '</span><i class="fas fa-chevron-down" aria-hidden="true"></i>');
	$label.attr('data-toggle', 'tooltip').attr('data-placement', 'bottom');
	$label.attr('title', firstName).addClass('dark-tooltip');

	$label.tooltip();

	setUpLogoutLink();
};

module.exports = {
	init: init
};
